module.exports = __webpack_public_path__ + "img/shangye_yangling_suoluetu.1894bbf2.png";